import React, { useState, useEffect } from 'react'
import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import { startLoading, doneLoading } from '../../../utils/loading'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import LawApproveWidget from '../../../widgets/lawApproveWidget/LawApproveWidget'

export default function LawApprove() {
  const [schema, setSchema] = useState()
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()

  const mockSchema = {
    affectedRows: 5,
    message: 'Successfully',
    success: true,
    didError: false,
    errorMessage: null,
    model: {
      header: 'พิจารณาอนุมัติโครงการ',
      subHeader: '',
      disabled: false,
      projectInfo: {
        projectVersionId: '705D6D37-47A2-4FDF-8E79-59738D0C9F7A',
        versionCode: '3.0',
        projectBasicInfoHeader: 'ข้อมูลทั่วไปของโครงการ',
        projectNameTitle: 'ชื่อโครงการ',
        projectName: 'การพัฒนาเทคโนโลยีสารสนเทศเพื่อการเกษตรครัวเรือน AC',
        projectNameEn: '',
        projectCodeTitle: 'รหัสโครงการ',
        projectCode: 'R65-00536',
        projectTypeTitle: 'ประเภทโครงการ',
        projectType: 'โครงการพัฒนาและปฏิบัติการ',
        projectProposalTypeTitle: 'ประเภทข้อเสนอโครงการ',
        projectProposalType: 'โครงการ',
        statueTitle: 'สถานะ',
        statue: 'กลั่นกรอง',
        projectProposalStyleTitle: 'ลักษณะข้อเสนอโครงการ',
        projectProposalStyle: 'โครงการใหม่',
        ownerNameTitle: 'ผู้ยื่นข้อเสนอ',
        ownerName: 'นาย xxx เยล',
        activityTypeTitle: 'ลักษณะกิจกรรม',
        activityTypeTitle2: '(ประเภทโครงการ)',
        activityType: 'โครงการพัฒนาและปฏิบัติการ',
        projectStatus: '4',
      },
      offeringApproveProposal: {
        headerApproveProposal: 'เสนอพิจารณาอนุมัติโครงการ',
        alert: null,
        textarea: {
          name: 'remark',
          label: 'ความเห็นของผู้อนุมัติ',
          value: '',
          processStatus: 0,
        },
        buttonOfferingApproveProposalLabel: 'เสนอพิจารณาอนุมัติ',
        buttonSendEditProposalLabel: 'ส่งกลับเพื่อแก้ไข',
        disabled: false,
      },
    },
  }

  const x = {
    header: 'พิจารณาอนุมัติโครงการ',
    projectInfo: {
      projectVersionId: '705D6D37-47A2-4FDF-8E79-59738D0C9F7A',
      versionCode: '3.0',
      projectBasicInfoHeader: 'ข้อมูลทั่วไปของโครงการ',
      projectNameTitle: 'ชื่อโครงการ',
      projectName: 'การพัฒนาเทคโนโลยีสารสนเทศเพื่อการเกษตรครัวเรือน AC',
      projectNameEn: '',
      projectCodeTitle: 'รหัสโครงการ',
      projectCode: 'R65-00536',
      projectTypeTitle: 'ประเภทโครงการ',
      projectType: 'โครงการพัฒนาและปฏิบัติการ',
      projectProposalTypeTitle: 'ประเภทข้อเสนอโครงการ',
      projectProposalType: 'โครงการ',
      statueTitle: 'สถานะ',
      statue: 'กลั่นกรอง',
      projectProposalStyleTitle: 'ลักษณะข้อเสนอโครงการ',
      projectProposalStyle: 'โครงการใหม่',
      ownerNameTitle: 'ผู้ยื่นข้อเสนอ',
      ownerName: 'นาย xxx เยล',
      activityTypeTitle: 'ลักษณะกิจกรรม',
      activityTypeTitle2: '(ประเภทโครงการ)',
      activityType: 'โครงการพัฒนาและปฏิบัติการ',
      projectStatus: '4',
    },
    budgetHeader: 'ขั้นที่ 1 ตรวจสอบงวดเงิน',
    budget: {
      budgetSummaryHeader: 'งบประมาณโครงการ',
      budgetSummary: 600000,
      alert: null,
      duration:
        '<b>ระยะเวลาดำเนินงาน</b> วันเริ่มดำเนินการ 22 ก.พ. 2565 วันสิ้นสุดโครงการ 22 ก.พ. 2566',
      periodExpensesHeader: 'งวดการเบิกจ่าย',
      buttionPeriodExpensesLabel: 'ยืนยันงบประมาณ',
      startProjectDate: '22 ก.พ. 2565',
      endProjectDate: '22 ก.พ. 2566',
      isDisabled: true,
      periodExpensesData: [
        {
          id: 'C0714213-46D2-4E9D-8B05-C761C1D3D6CC',
          list: 'งวดที่ 1',
          cost: 0,
          withholdingTax: 0,
          date: '25 มี.ค. 2565',
          year: '2565',
          startDate: '25 มี.ค. 2565',
          endDate: '25 มี.ค. 2565',
          isEBudget: null,
          numberOfInstallment: 1,
          detail: {
            name: 'C0714213-46D2-4E9D-8B05-C761C1D3D6CC',
            label: 'รายละเอียดผลงาน',
            value: null,
          },
          children: [],
        },
      ],
    },
    projectBudgetPlan: {
      header: 'ระบุแผน',
      buttonBudgetPlanSaveLabel: '',
      masterBudgetPlan: {
        label: 'แผนหลัก',
        value: '010111',
        text: 'กลุ่มแผนงานด้านการพัฒนานโยบายสาธารณะและการบังคับใช้กฎหมาย',
      },
      masterBudgetValue: {
        label: 'จำนวน',
        value: 600000,
      },
      subBudgetPlan: {
        label: 'แผนรอง',
        value: null,
        text: '',
      },
      subBudgetValue: {
        label: 'จำนวน',
        value: 0,
      },
    },
    granteeProfileHeader: 'ขั้นที่ 2 ตรวจสอบข้อมูลผู้รับทุน',
    granteeProfile: {
      granteeProfileHeader: 'ข้อมูลผู้ขอรับทุน',
      blacklistStatus: 'สถานะ Backlist',
      progressSummary: 'สรุปการดำเนินโครงการ',
      progressHistory: 'ประวัติดำเนินโครงการ',
      granteeStatus: false,
      granteeProfile: {
        granteeNameTitle: 'ชื่อผู้ขอรับทุนโครงการ',
        granteeName: 'นาย xxx เยล',
        granteeNameTitleEN: 'ชื่อผู้ขอรับทุนโครงการ (ภาษาอังกฤษ)',
        granteeNameEN: 'นาย xxx เยล',
        departmentTitle: 'หน่วยงานสังกัด',
        department: '-',
        addressTitle: 'ที่อยู่ที่สามารถติดต่อได้',
        address:
          'เลขที่  อาคาร  หมู่ที่  ถ. ต.พระบรมมหาราชวัง อ.เขตพระนคร จ.กรุงเทพมหานคร รหัสไปรษณีย์10200',
        telephoneTitle: 'โทรศัพท์',
        telephone: '1010101010',
        emailTitle: 'อีเมล',
        email: 'wanlop.bunprasroet@gmail.com',
        checkValidity: 'การตรวจสอบความถูกต้อง',
        checkStatusTitle: 'สถานะตรวจสอบ',
        checkStatus: 'ไม่ผ่านการตรวจสอบ',
        modifyDateTitle: 'ข้อมูลปรับปรุง เมื่อวันที่',
        modifyDate: '',
        checkCOIValidity: 'การตรวจสอบการมีส่วนได้ส่วนเสีย (COI)',
        checkCOIStatusTitle: 'สถานะตรวจสอบ',
        checkCOIStatus: '',
        modifyCOIDateTitle: 'ข้อมูลปรับปรุง เมื่อวันที่',
        modifyCOIDate: '',
      },
      blacklist: {
        statusTitle: 'สถานะ',
        status: 'ไม่ได้อยู่ในรายชื่อแบล็คลิส',
      },
      tableProjectSummary: {
        projectStatusTitle: 'สถานะโครงการ',
        quantityTitle: 'จำนวน',
        percentTitle: 'ร้อยละ',
        tableData: [
          {
            id: 'B6485574-1E5D-4D45-B83F-7A6E1C304882',
            status: 'กลั่นกรอง',
            projectSummary: 23,
            summaryPercent: 26.74,
          },
          {
            id: 'B6485574-1E5D-4D45-B83F-7A6E1C304882',
            status: 'คัดกรอง',
            projectSummary: 8,
            summaryPercent: 9.3,
          },
          {
            id: 'B6485574-1E5D-4D45-B83F-7A6E1C304882',
            status: 'ดำเนินการ',
            projectSummary: 10,
            summaryPercent: 11.63,
          },
          {
            id: 'B6485574-1E5D-4D45-B83F-7A6E1C304882',
            status: 'ไม่เข้าข่าย (สสส.)',
            projectSummary: 2,
            summaryPercent: 2.33,
          },
          {
            id: 'B6485574-1E5D-4D45-B83F-7A6E1C304882',
            status: 'ยื่นข้อเสนอโครงการ',
            projectSummary: 6,
            summaryPercent: 6.98,
          },
          {
            id: 'B6485574-1E5D-4D45-B83F-7A6E1C304882',
            status: 'ยุติโครงการ',
            projectSummary: 1,
            summaryPercent: 1.16,
          },
          {
            id: 'B6485574-1E5D-4D45-B83F-7A6E1C304882',
            status: 'รอยกเลิกโครงการ',
            projectSummary: 3,
            summaryPercent: 3.49,
          },
          {
            id: 'B6485574-1E5D-4D45-B83F-7A6E1C304882',
            status: 'ร่างข้อเสนอ',
            projectSummary: 9,
            summaryPercent: 10.47,
          },
          {
            id: 'B6485574-1E5D-4D45-B83F-7A6E1C304882',
            status: 'อนุมัติ',
            projectSummary: 24,
            summaryPercent: 27.91,
          },
        ],
      },
      tableProjectHistory: {
        projectCodeTitle: 'รหัสโครงการ',
        projectNameTitle: 'ชื่อโครงการ',
        projectTypeTitle: 'ประเภทโครงการ',
        projectResultTitle: 'ผลพิจารณากลั่นกรอง',
        projectStausTitle: 'สถานะ',
        tableData: [
          {
            id: 'R65-00536',
            type: {
              icon: 'file-o',
              label: 'โครงการ',
            },
            projectName: 'การพัฒนาเทคโนโลยีสารสนเทศเพื่อการเกษตรครัวเรือน AC',
            colorstatus: {
              code: '4',
              label: 'กลั่นกรอง',
            },
            status: 'กลั่นกรอง',
            result: 'รอพิจารณา',
          },
        ],
      },
    },
    approveProposalHeader: 'ขั้นที่ 3 พิจารณาอนุมัติโครงการ',
    attorney: {
      disabled: true,
      attorneyType: {
        header: 'รับมอบอำนาจ',
        options: [
          {
            name: 'checkbox2',
            disabled: true,
            label: 'มอบอำนาจยื่นเสนอโครงการ',
            value: '2',
          },
          {
            name: 'checkbox3',
            disabled: true,
            label: 'มอบอำนาจเป็นผู้รับผิดชอบโครงการ',
            value: '3',
          },
          {
            name: 'checkbox4',
            disabled: true,
            label: 'มอบอำนาจลงนามในสัญญา',
            value: '4',
          },
        ],
        optionSelected: [],
      },
      attorneyPerson: [],
    },
    uploadDocuments: {
      header: 'อัปโหลดเอกสารแนบ',
      fileList: {
        name: 'attachFiles',
        value: [],
      },
    },
  }

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      // const request = {
      //   lawType: null,
      //   projectCode: null,
      //   docNumberOfPurchase: null,
      //   contractNumberRef: null,
      //   pageNumber: 1,
      //   pageSize: 5,
      // }

      // const _schema = await getLegalManagement(request)
      // console.log('getLegalManagement 0000.....', _schema)
      setSchema(mockSchema.model)
      // if (_schema.success) {
      //   setSchema(_schema.model)
      // }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
    doneLoading()
    setIsLoading(false)
  }

  useEffect(() => {
    handleGetSchema()
  }, [])

  console.log('gggg ', schema)

  if (error) {
    return (
      <SidebarProposal isLegalManagement>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal isLegalManagement>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal isLegalManagement>
        <ContentHeader header={schema.header} subHeader={schema.subHeader} isNotCallApi />

        <LawApproveWidget schema={schema} />

        <br />
    </SidebarProposal>
  )
}
